import { MerchantServiceApiFactory } from '@layup/api-sdk';
import { createLayupClient } from './layupApi';

export const getShops = async () => {
  const client = createLayupClient(true, false);
  const api = MerchantServiceApiFactory(undefined, undefined, client);
  const response = await api.merchantServiceGetShopsV2();
  return response.data;
};
